const bootstrapAPIs = {
	FETCH_APP_CONFIG: 'fetchAppConfig',
};

const studentAPIs = {
	FETCH_STUDENTS: 'fetchStudents',
	FETCH_STUDENT_BY_ID: 'fetchStudentById',
	FETCH_STUDENT_BY_PHONE: 'fetchStudentByPhone',
	UPDATE_STUDENT_BY_ID: 'updateStudentById',
	CREATE_STUDENT: 'createStudent',
	MARK_STUDENT_ID_CARD_STATUS: 'markStudentsIdCardStatus',
};

const attendanceAPIs = {
	FETCH_ATTENDANCE: 'fetchAttendance',
	UPDATE_ATTENDANCE: 'updateAttendance',
	DOWNLOAD_ATTENDANCE_REPORT: 'downloadAttendanceReport',
};

const loginAPIs = {
	USER_AUTH: 'login',
};

const classroomAPIs = {
	FETCH_CLASSROOMS: 'fetchClassRooms',
	FETCH_CLASSROOMS_BY_LEVEL: 'fetchClassRoomsByLevel',
};

const fileAPIs = {
	FETCH_DOCUMENT: 'fetchDocument',
	FETCH_FILE_DETAILS: 'fetchFileDetails',
	UPLOAD_DOCUMENT: 'uploadDocument',
	DELETE_DOCUMENT: 'deleteDocument',
};
const coordinatorAPIs = {};

const shivirDetailsAPIs = {
	FETCH_SHIVIR_DETAILS: 'fetchShivirDetails',
};

export const API = {
	...attendanceAPIs,
	...bootstrapAPIs,
	...classroomAPIs,
	...coordinatorAPIs,
	...loginAPIs,
	...studentAPIs,
	...fileAPIs,
	...shivirDetailsAPIs,
};
